<template>
  <div class='content-wrapper'>
    <Breadcrumb :title="$t('personalMenu-notificationSettings')" />
    <div class='content-body'>
      <div class='row'>
        <div class='col-xl-8 col-lg-8 col-md-12'>
          <section class='card'>
            <div class='card-content'>
              <div class='card-body'>
                <Notification />
              </div>
            </div>
          </section>
        </div>
        <Sidebar />
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/personal/Sidebar.vue';
import Notification from '@/components/personal/Notification.vue';
import Breadcrumb from '@/components/layout/Breadcrumb';

export default {
  name: 'NotificationSettings',
  components: {
    Sidebar,
    Notification,
    Breadcrumb
  }
};
</script>

<style scoped></style>
